export const emptyGlobalVariant: GlobalVariant = {
  id: 0,
  title: '',
  name: '',
  productName: '',
  productId: 0,
  description: '',
  image: '',
  options: [],
  price: 0,
};

export const emptyGlobalProduct: GlobalProduct = {
  id: 0,
  title: '',
  description: '',
  descriptionHtml: '',
  price: 0,
  image: '',
  variants: [],
};
